<template>
  <div class="c-items-double">
    <div class="image" @click="goto()">
      <img :src="info.coverUrl || './images/img01.jpg'" />
    </div>
    <div class="content">
      <div class="date">{{ info.startTime }}</div>
      <div class="title">{{ info.title }}</div>
      <div class="opea">
        <div
          class="button"
          :style="{
            color: sett.buttonTextColor,
            backgroundColor: sett.buttonColor
          }"
          @click="goto()"
        >
          <span>{{ sett.buttonText || $t("RESERVATION_NOW") }}</span>
          <a-icon type="right" class="icon-btn"></a-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { interact } from "fire-wind-water/tools/interact";

export default {
  name: "ItemDouble",
  data() {
    return {
      isMobile: interact.isMobile
    };
  },
  props: {
    info: {},
    sett: {}
  },
  methods: {
    goto() {
      if (interact.isMobile == 1) {
        window.location.href = this.info.wapUrl;
      } else {
        window.open(this.info.pcUrl);
      }
    }
  }
};
</script>

<style scoped></style>
